import request from '@/utils/request'

// 获取账户组列表
export const getAccountGroupList = (params: any) => request({
  url: '/manage/product-account-group',
  method: 'get',
  params
})

// 获取账户组详情
export const getAccountGroupListInfo = (params: any) => request({
  url: '/manage/product-account-group/' + params.id,
  method: 'get',
  params
})

// 创建账户组
export const addAccountGroup = (data: any) => request({
  url: '/manage/product-account-group',
  method: 'post',
  data
})

// 编辑账户组
export const editAccountGroupList = (data: any) => request({
  url: '/manage/product-account-group/' + data.id,
  method: 'patch',
  data
})

// 删除账户组
export const delAccountGroup = (params: any) => request({
  url: '/manage/product-account-group/' + params.id,
  method: 'delete'
})